module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "deliveryArea"
    }
  }, [_c('div', {
    staticClass: "deliveryArea-header"
  }, [_c('img', {
    staticClass: "deliveryArea-header-close",
    attrs: {
      "src": require("../../../assets/icon/close2.png")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deliveryArea-header-title"
  }, [_vm._v("查看配送区域")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('hr', {
    staticClass: "deliveryArea-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "deliveryArea-search"
  }, [_c('div', {
    staticClass: "deliveryArea-search-textfield"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/icon/search.jpg"),
      "id": "deliveryArea-search-img"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addr),
      expression: "addr"
    }],
    staticClass: "deliveryArea-search-lable",
    staticStyle: {
      "color": "#191919"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入地址查看是否在配送范围内"
    },
    domProps: {
      "value": (_vm.addr)
    },
    on: {
      "focus": _vm.lableOnFocus,
      "blur": _vm.lableOnBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addr = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "deliveryArea-content"
  }, [_c('baidu-map', {
    staticClass: "map-container",
    attrs: {
      "ak": "kG0GHj7Kn2EzPRsRhog4BvWW5zoEskNl",
      "center": _vm.center,
      "zoom": _vm.zoom,
      "min-zoom": 10,
      "max-zoom": 13,
      "inertial-dragging": true,
      "scroll-wheel-zoom": true
    },
    on: {
      "ready": _vm.handler
    }
  }, [_vm._l((_vm.polygonPaths), function(polygonPath, index) {
    return _c('bm-polygon', {
      key: index,
      attrs: {
        "path": polygonPath,
        "stroke-color": "#3d2d23",
        "stroke-opacity": 0.5,
        "fillColor": "#3d2d23",
        "stroke-weight": 1,
        "fill-opacity": 0.2
      }
    })
  }), _vm._v(" "), (_vm.currentCenter !== undefined) ? _c('bm-marker', {
    attrs: {
      "position": _vm.currentCenter,
      "animation": "BMAP_ANIMATION_BOUNCE"
    }
  }) : _vm._e(), _vm._v(" "), _c('bm-local-search', {
    attrs: {
      "keyword": _vm.addr,
      "auto-viewport": false,
      "panel": false,
      "selectFirstResult": false
    },
    on: {
      "markersset": _vm.markerssetEvent,
      "searchcomplete": _vm.searchcomplete
    }
  })], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchView === true),
      expression: "showSearchView === true"
    }],
    staticClass: "deliveryArea-content deliveryArea-content-locationView",
    on: {
      "click": _vm.hideEvent
    }
  }, [_c('div', {
    staticClass: "deliveryArea-content-resultView"
  }, _vm._l((_vm.results), function(address) {
    return _c('div', {
      staticClass: "deliveryArea-content-addr",
      on: {
        "click": function($event) {
          _vm.selectedAddr(address)
        }
      }
    }, [_c('div', {
      staticClass: "deliveryArea-content-lable",
      staticStyle: {
        "margin-left": "20px",
        "margin-right": "20px"
      }
    }, [_vm._v(_vm._s(address.title) + " - " + _vm._s(address.address))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fae48a42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/deliveryArea/deliveryArea.vue
// module id = 596
// module chunks = 1